// extracted by mini-css-extract-plugin
module.exports = {"root":"_6a7d83","bar":"_b4c441","teal":"_95bc34","yellow":"_e9f76f","orange":"_2e831d"};